import { VideoService } from './../services/video.service';
import { ActivatedRoute, Router, ParamMap } from '@angular/router';
import { Component, OnInit, OnChanges } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { switchMap } from 'rxjs/operators';


@Component({
  selector: 'app-videos',
  templateUrl: './videos.component.html',
  styleUrls: ['./videos.component.css']
})

export class VideosComponent implements OnInit,OnChanges {

  private videoList: Array<any>
  private videoList$: Observable<Array<any>>;
  private bundleId = + this.route.snapshot.paramMap.get('id');

    
    constructor(
      private route: ActivatedRoute,  
      private router: Router,
      private videoService: VideoService
      ) { }

  ngOnInit() {
     this.route.paramMap
     .subscribe((params)=>{
       let id = parseInt(params.get("id"));
       console.log(params.get("id"))
      if(id == 1){
        this.videoList = this.videoService.getExercisesByBundleId(id);
      }else if(id == 99){
        this.videoList = JSON.parse(localStorage.getItem("exampleExercises"));
      }else {
        this.videoList = this.videoService.getExerciseByCategoryId(id);
      }
      console.log("videoList2", this.videoList);
      console.log(this.videoList)
     })
  }

  ngOnChanges(changes){
    console.log(changes)
    this.videoList = this.videoService.getExercisesByBundleId(this.bundleId);

  }

	getVideoList(){
    this.videoService.getExercises().then((res:Array<any>)=>{
      console.log(res);
      this.videoList = res;
    });

    const starter = this.videoService.getExercisesByBundleId(1);
    console.log(starter)

  }

}



// WEBPACK FOOTER //
// ./src/app/videos/videos.component.ts